import { render } from "./UpgradeRegistration.vue?vue&type=template&id=17c92afe&scoped=true&ts=true&lang=pug"
import script from "./UpgradeRegistration.vue?vue&type=script&lang=ts"
export * from "./UpgradeRegistration.vue?vue&type=script&lang=ts"

import "./UpgradeRegistration.vue?vue&type=style&index=0&id=17c92afe&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./UpgradeRegistration.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/upgrade-registration.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FUpgradeRegistration.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c92afe"]])

export default __exports__